module.exports = __webpack_public_path__ + "static/media/charity.cd1c31ff.png";